export const formatCurrency = (inputValue: string): string => {
        let numericValue = inputValue.replace(/\D/g, ""); // Remove tudo que não for número
        let formattedValue = (Number(numericValue) / 100).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
        });

        return formattedValue.replace("R$", "").trim(); // Remove "R$" para evitar duplicação
};

export const formatCurrencyToFloat = (value: string): number => {
        let valueFormmater = value;
        valueFormmater = valueFormmater.replace(/R\$\s*/g, ''); // Remove todas as ocorrências de 'R$' e espaços após
        valueFormmater = valueFormmater.replace(/\s+/g, ''); // Remove todos os espaços extras
        valueFormmater = valueFormmater.replace(/\./g, ''); // Remove todos os pontos (separadores de milhar)
        valueFormmater = valueFormmater.replace(/,/g, '.'); // Substitui todas as vírgulas por pontos
        return Number(valueFormmater); // Substitui todas as vírgulas por pontos
};

export const formatNumber = (num: number, validateNegative = true) => {
  if(validateNegative && num <=0)
    return 0;

  const format = (value: number, suffix: string) => {
    let formatted = (value).toFixed(1);
    // remove ",0" ou ".0"
    formatted = formatted.replace(/(\.|,)0$/, '');
    // troca ponto por vírgula (formato pt-BR)
    formatted = formatted.replace('.', ',');
    return formatted + suffix;
  };

  if (num >= 1_000_000_000) {
    return format(num / 1_000_000_000, 'B');
  } else if (num >= 1_000_000) {
    return format(num / 1_000_000, 'M');
  } else if (num >= 1_000) {
    return format(num / 1_000, 'K');
  } else {
    return num.toLocaleString('pt-BR');
  }
};
